import theme from '../../../lib/theme';
import { CalloutProps } from './Callout';

const { corners, scale, colors, layouts } = theme;

export default ({ sticky }: CalloutProps) => ({
  callout: {
    ...layouts.column,

    borderRadius: corners.m,
    overflow: 'hidden',
    position: sticky ? 'sticky' : 'static',
    top: sticky ? `calc(60px + ${scale.s})` : undefined,
    backgroundColor: colors.travel360.primary_light,
  },

  calloutHeading: {
    color: colors.sas.primary,
    padding: `${scale.xs} ${scale.s} 0`,
  },

  calloutBody: {
    ...layouts.spacedColumn('s'),

    padding: `${scale.xs} ${scale.s} ${scale.s}`,
  },

  authorCalloutMetaContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'between',
    gap: '1em',
    padding: `${scale.xs} ${scale.s} ${scale.s}`,
  }
});
